module.exports = __webpack_public_path__ + "static/img/gaozhongwuli5.31ba012b.jpg";